/** @jsx jsx */
import { jsx } from "@emotion/react";
import React, { FC, ReactNode } from "react";
import { ModuleId, ModuleIds } from "../../../../../../globalTypes";
import FavouriteTemplates from "../../FavouriteTemplates";
import ModuleDropdown from "./ModuleDropdown";

export type ModulesProps = {
  moduleIds: ModuleIds;
  closeNav: () => void;
};

const Modules: FC<ModulesProps> = ({ moduleIds, closeNav }) => {
  const idToDropdown = (id: ModuleId): ReactNode => {
    if (id === -1) return <FavouriteTemplates key={id} />;

    return <ModuleDropdown key={id} moduleId={id} closeNav={closeNav} />;
  };

  return <React.Fragment>{moduleIds.map(idToDropdown)}</React.Fragment>;
};

export default Modules;
